








import { iosCustomUrlSchemes } from '@/models/hl-app/custom-url-scheme'
import ErrorView from '@spa/hl-app/components/error/ErrorView.vue'
import Vue from 'vue'
import { Component } from 'vue-mixin-decorator'

@Component({
  components: {
    ErrorView,
  },
})
export default class AuthError extends Vue {
  closePage(): void {
    location.href = iosCustomUrlSchemes.close
  }
}
